import { render, staticRenderFns } from "./statisticFromStatus.vue?vue&type=template&id=1d5148f9&"
import script from "./statisticFromStatus.vue?vue&type=script&lang=js&"
export * from "./statisticFromStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports